import type { HoldingDto } from '@hcr/api/consumer'
import { HoldingWeekTypeDto } from '@hcr/api/consumer'

export const isHoldingVilla = (holding: HoldingDto): boolean => {
  return (
    holding.week_type === HoldingWeekTypeDto.VillasFullOwnership ||
    holding.week_type === HoldingWeekTypeDto.VillasFractional
  )
}
